import {
  EditIcon,
  EllipsisIcon,
  ExternalLinkIcon,
  SendIcon,
} from "lucide-react"
import { useState } from "react"
import { useNavigate } from "react-router-dom"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
interface WebhookDropdownActionProps {
  webhook: WebhookConfigurationType
}
export const WebhookDropdownAction = ({
  webhook,
}: WebhookDropdownActionProps) => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const handlePing = async () => {
    setIsLoading(true)
    try {
      // TODO: Implementar chamada ao endpoint de ping do webhook
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_error) {
      // TODO: Tratar erro ao enviar ping
    } finally {
      setIsLoading(false)
    }
  }
  const handleViewDetails = () => {
    navigate(`/webhooks/details/${webhook.id}`)
  }
  const handleEdit = () => {
    navigate(`/webhooks/edit/${webhook.id}`)
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="flex justify-end">
          <Button
            size="icon"
            variant="ghost"
            className="shadow-none"
            aria-label="Ações"
          >
            <EllipsisIcon
              size={16}
              strokeWidth={2}
              aria-hidden="true"
            />
          </Button>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="space-y-1"
      >
        <DropdownMenuItem asChild>
          <Button
            variant="ghost"
            size="sm"
            className="w-full cursor-pointer justify-start"
            onClick={handleViewDetails}
          >
            <ExternalLinkIcon size={16} className="mr-2" />
            Detalhes
          </Button>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Button
            variant="ghost"
            size="sm"
            className="w-full cursor-pointer justify-start"
            onClick={handleEdit}
          >
            <EditIcon size={16} className="mr-2" />
            Editar
          </Button>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Button
            variant="ghost"
            size="sm"
            className="w-full cursor-pointer justify-start"
            onClick={handlePing}
            disabled={isLoading}
          >
            <SendIcon size={16} className="mr-2" />
            {isLoading ? "Enviando..." : "Ping"}
          </Button>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
